import styled from 'vue-styled-components';

export const NoItemMessage = styled.div`
    padding: 12px 16px;
    background-color: #fff;
    color: #949aa1;
    font-size: 13px;
    font-weight: 500;
    text-align: center;
`;

export const OptionsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    height: 100%;
`;
